export default {
  title_one: 'Eenmalig gebruik, {{discount}}',
  title_other: '{{count}} gebruik, {{discount}}',
  labels: {
    fixed_discount: '{{discount}} totale korting',
    percentage_discount: 'Percentagekorting',
  },
  buttons: {
    add_component: 'Gebruik toevoegen',
  },
};
